import { hashCodeq5arwsb9dgti as hashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function hashCodeOf(first, others) {
  var prime = 31;
  var result = prime + hashCode(first) | 0;
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = others.length;
  while (inductionVariable < last) {
    var element = others[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    result = imul(prime, result) + hashCode(element) | 0;
  }
  return result;
}
//region block: exports
export {
  hashCodeOf as hashCodeOf2bangq6jexew2,
};
//endregion

//# sourceMappingURL=AnyX.mjs.map
